import * as React from 'react'
import styled from 'styled-components'
import { DisplaySmall, spacing, color, palette } from '@conserveit/blocks'

const Wrapper = styled.div`
  width: 100%;
  padding: ${spacing.extraLoose};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${color.theme.typography.subdued};
  background-color: ${palette.neutralAlt1};
  margin-top: ${spacing.tight};
`

export const NoResult: React.FC = () => {
  return (
    <Wrapper>
      <DisplaySmall>No data available. Try increasing the selected time frame.</DisplaySmall>
    </Wrapper>
  )
}
